import { ReactNode } from "react";
import styled from "styled-components";

type AppContainerProps = {
  children: ReactNode;
};

const AppContainerWrapper = styled.div`
  /* flex-grow: 1; */
`;

const AppContainer = ({ children }: AppContainerProps) => {
  return (
    <>
      <AppContainerWrapper>
        <main>{children}</main>
      </AppContainerWrapper>
    </>
  );
};

export default AppContainer;
